module.exports = __webpack_public_path__ + "img/emoji_qiang.586d3ab6.png";